import React from 'react';

const RythmIcon = () => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_7431_33197)">
				<mask id="mask0_7431_33197" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
					<rect width="24" height="24" fill="#D9D9D9"/>
				</mask>
				<g mask="url(#mask0_7431_33197)">
					<path d="M7.49984 13.6666V4.91659H8.49984V13.6666H7.49984ZM4.91017 11.7243V6.85242H5.91V11.7243H4.91017ZM10.0897 11.7243V6.85242H11.0895V11.7243H10.0897ZM2.32034 9.78842V8.78842H3.32034V9.78842H2.32034ZM12.6793 9.78842V8.78842H13.6793V9.78842H12.6793ZM1.6665 6.56408V5.56408H2.27684C2.7575 5.56408 3.20673 5.44525 3.6245 5.20759C4.04228 4.97003 4.3755 4.64697 4.62417 4.23842C4.98062 3.64353 5.45806 3.17731 6.0565 2.83975C6.65495 2.50209 7.30278 2.33325 8 2.33325C8.69734 2.33325 9.34512 2.50209 9.94334 2.83975C10.5417 3.17731 11.0191 3.64353 11.3755 4.23842C11.6199 4.64697 11.9503 4.97003 12.3665 5.20759C12.7827 5.44525 13.2348 5.56408 13.7228 5.56408H14.3332V6.56408H13.7332C13.0759 6.56408 12.4603 6.40359 11.8863 6.08259C11.3124 5.7617 10.8584 5.32047 10.5242 4.75892C10.2601 4.3127 9.90384 3.96353 9.4555 3.71142C9.00717 3.45931 8.52195 3.33325 7.99984 3.33325C7.48895 3.33325 7.00934 3.45931 6.561 3.71142C6.11256 3.96353 5.75628 4.3127 5.49217 4.75892C5.15373 5.32047 4.6975 5.7617 4.1235 6.08259C3.54962 6.40359 2.93406 6.56408 2.27684 6.56408H1.6665Z" fill="currentColor"/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_7431_33197">
					<rect width="16" height="16" fill="white"/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default RythmIcon;
